import { buildBackendUrl } from './backendUrl';
import { buildMedhugRequestHeaders } from '../utils/requestHeaders';

export const TAPNATIVE_AIM_TRACE_PATH = '/tapnative-aim-trace';

async function parseJsonResponse(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

function buildError(data, fallback) {
  const error = new Error(data.message || data.error || fallback);
  error.code = data.error;
  error.data = data;
  return error;
}

export async function captureTapNativeAimTrace(payload) {
  const response = await fetch(buildBackendUrl(TAPNATIVE_AIM_TRACE_PATH), {
    method: 'POST',
    headers: buildMedhugRequestHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
    body: JSON.stringify(payload || {}),
  });

  const data = await parseJsonResponse(response);
  if (!response.ok) {
    throw buildError(data, 'Unable to record TapNative AIM trace.');
  }
  return data;
}
